var layout_default = {
  "layoutWrapper": "w1kwL",
  "layout": "wKzfQ",
  "designOnLayout": "R5X6J",
  "designOnCell": "TmN7N",
  "cell": "G3DTf",
  "mobile": "rJHS-"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
